import React, { useEffect, useState } from 'react';
import { IStyleSettings } from 'types';
import { hexToRgb, rgbToHex } from 'utils/helpers';
import Text from 'components/Text/Text';

interface IProps {
	data: IStyleSettings;
	setStyleSettings: (styleItemId: string, value: string, key: string) => void;
}

export const StyleInputNew: React.FC<IProps> = React.memo(({ data, setStyleSettings }) => {
	const [hexColor, setHexColor] = useState<string>(rgbToHex(data.value));
	const [rgbColor, setRgbColor] = useState<string>(data.value);
	const [isFirstChanges, setIsFirstChanges] = useState<boolean>(true);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setHexColor(e.target.value);
		if (isFirstChanges) {
			setIsFirstChanges(false);
		}
	};

	useEffect(() => {
		const timeoutID = setTimeout(() => {
			const rgb = hexToRgb(hexColor);
			setRgbColor(`rgb(${rgb?.r},${rgb?.g},${rgb?.b})`);
		}, 800);
		return () => clearTimeout(timeoutID);
	}, [hexColor]);

	useEffect(() => {
		if (!isFirstChanges) {
			setStyleSettings(data.id, rgbColor, data.key);
		}
	}, [rgbColor]);

	return (
		<div className="p-4 rounded flex items-start gap-2 bg-blue-01-new" data-test={`ColorInput-${data.key}`}>
			<label className="relative shrink-0 cursor-pointer">
				<div
					className="w-20 h-20 border-2 border-solid border-blue-02-new rounded-sm"
					style={{ background: hexColor }}
				/>
				<input className="sr-only" type="color" name={data.id} value={hexColor} onChange={handleChange} />
			</label>
			<div className="min-w-0 flex-1 self-stretch flex flex-col justify-center gap-2">
				<Text
					translationNameSpace="mediaSettings"
					translationKey={data.key}
					size="xs"
					weight="bold"
					withTooltip={true}
					isNewTooltip={true}
				/>
				<Text translationKey={rgbColor} size="xs" withTooltip={true} isNewTooltip={true} />
			</div>
		</div>
	);
});
